import { Account } from '@modules-deprecated/app/accounts/types'

import { SelectableProductAccount } from '../../../query-api'

/**
 * Appends a legacy (out-of-range) account to the curated selectable list so an older product's
 * `accountId` stays visible/selectable when editing. The legacy account is only appended when it's
 * not already present: react-query keeps the legacy `fetchAccount` result cached even after its
 * query is disabled, so without this guard an account that the curated list later includes could be
 * listed twice.
 */
export const getSelectableAccountsWithLegacy = (
  accounts: SelectableProductAccount[],
  legacyAccount?: Account,
): SelectableProductAccount[] => {
  if (!legacyAccount || accounts.some((account) => account.id === legacyAccount.id)) {
    return accounts
  }

  const { id, name, accountNo, publicAccountId, natureId } = legacyAccount

  return [...accounts, { id, name, accountNo, publicAccountId, natureId }]
}
